<template>
  <div class="about-us-container">
    <div class="image-container">
      <div class="row" v-for="(item, index) in imageList" :key="index">
        <img :src="item" />
      </div>
    </div>
    <viewFooter></viewFooter>
  </div>
</template>

<script>
import viewFooter from '@/views/view-footer.vue'
export default {
  name: "HomeIntro",
  components: {
    viewFooter
   },
  data() {
    return {
      imageList: [
        // require('@/assets/homeInfor/picture1.png'),
        require('@/assets/homeInfor/one.png'),
        require('@/assets/homeInfor/two.png'),
        require('@/assets/homeInfor/three.png'),
        require('@/assets/homeInfor/four.png'),
        require('@/assets/homeInfor/five.png'),
        require('@/assets/homeInfor/six.png'),
        require('@/assets/homeInfor/seven.png'),
        require('@/assets/homeInfor/eight.png'),
        require('@/assets/homeInfor/nine.png'),
        require('@/assets/homeInfor/ten.png'),
      ],
    };
  },
};
</script>

<style scoped>
.row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0; /* 每张图片上下留点间距 */
}

.row img {
  width: 84%; /* 图片宽度改为屏幕宽度的 80% */
  max-width: 1200px; /* 限制最大宽度 */
  height: auto;
  object-fit: contain; /* 保持比例，不裁切 */
  display: block;
  border-radius: 8px; /* 图片四角微微圆润，更美观 */
}

/* 大屏（1920px+） */
@media (min-width: 1920px) {
  .row img {
    width: 70%; /* 大屏图片更小 */
    max-width: 1400px;
  }
}

/* 平板（768px ~ 1023px） */
@media (max-width: 1023px) and (min-width: 768px) {
  .row img {
    width: 90%;
  }
}

/* 手机（小于 768px） */
@media (max-width: 767px) {
  .row img {
    width: 100%;
    max-width: 100%;
  }
}
</style>
